<template>
  <div class="chat-input">
    <div class="input-container">
      <input
        v-model="newMessage"
        type="text"
        placeholder="Type your message..."
        class="message-input"
        :disabled="isLoading"
        @keyup.enter="sendMessage"
      />
      <button class="send-btn" :disabled="!newMessage.trim() || isLoading" @click="sendMessage">
        <svg
          v-if="!isLoading"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="22" y1="2" x2="11" y2="13"></line>
          <polygon points="22,2 15,22 11,13 2,9"></polygon>
        </svg>
        <div v-else class="loading-spinner"></div>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IChatMessage, IChatRequest } from "../interfaces/chatBotInterfaces";
import { useChatBotStore } from "../stores/chatBotStore";

import { ref } from "vue";
import { v4 as createGuid } from "uuid";
import { formatChatMessage } from "format-chat-message";
import { chatBotApi } from "@/common";

const newMessage = ref("");
const isLoading = ref(false);
const chatBotStore = useChatBotStore();
const chatId = ref(createGuid());

function copyStringWithoutReference(text: string) {
  return (" " + text).slice(1);
}

const sendMessage = async () => {
  if (!newMessage.value.trim() || isLoading.value) return;
  const question = copyStringWithoutReference(newMessage.value.trim());
  newMessage.value = "";

  const userMessage: IChatMessage = {
    id: Date.now().toString(),
    type: "user",
    text: question,
    timestamp: new Date(),
  };

  chatBotStore.messages.push(userMessage);

  // Simulate bot response
  isLoading.value = true;

  const responseText = await ask(question);
  const botMessage: IChatMessage = {
    id: (Date.now() + 1).toString(),
    type: "bot",
    text: responseText,
    timestamp: new Date(),
  };
  chatBotStore.messages.push(botMessage);
  isLoading.value = false;
};

async function ask(question: string): Promise<string> {
  try {
    const request = {
      sessionId: chatId.value,
      message: question,
      brand: "Safe",
    } as IChatRequest;

    const response = (await chatBotApi.ask(request)).data;
    chatId.value = response.sessionId;
    console.log(chatId.value);

    return formatChatMessage({ message: response.answer }) || "No response from bot.";
  } catch (error) {
    console.error("Error fetching token:", error);
    return "Error Error. Does not compute"; // Rethrow the error after logging it
  }
}
</script>
